<div class="row justify-content-between">
  <div class="form-group col-2">
    <label for="selectedNotificationCategory" class="sr-only">
      View</label>
    <select id="selectedNotificationCategory" [(ngModel)]="selectedNotificationCategory"
      aria-describedby="instructionTxt" [ngModelOptions]="{standalone: true}" class="custom-select"
      (change)="getFilteredNotifications()">
      <option [ngValue]="category.value" *ngFor="let category of notificationCategoryList">{{category.name}}</option>
    </select>
    <p class="sr-only m-0" id="instructionTxt">The result below will be filtered as soon as new value is selected from
      the combobox.</p>
  </div>

  <div class="col-4 p-0 text-right">
    <button
        type="button"
        class="btn btn-clear text-underline"
        (click)="markNotificationAsRead()">
        Mark all as read
    </button>
    <p *ngIf="markedRead" role="alert">Marked all read</p>
  </div>
</div>

<app-preloader *ngIf="loadingNotification===true" [loaderText]="'Loading Notifications'"
  class="w-100 position-fixed preloader-backdrop"></app-preloader>
<p role="alert" class="text-center" *ngIf="filteredNotificationList && filteredNotificationList.length < 1">
  No data found.
</p>
<ng-container *ngIf="loadingNotification===false">
  <ul class="mb-0 list-unstyled">
    <li *ngFor="let item of filteredNotificationList">
      <section class="row update mb-4" attr.aria-labelledby="{{item.key }}">
        <div class="col-12">
          <h2 id="{{item.key }}" class="h2 text-truncate font-bold mb-2">{{item.key }}</h2>
          <ul class="mb-0 list-unstyled">
            <li *ngFor="let notification of item.value;">
              <div class="d-flex justify-content-between list-view py-2 mb-3">
                <div class="col">
                  <p id="{{notification.description}}" class="mb-0">
                    <span>{{notification.description}}</span>
                  </p>
                  <p class="time mb-0">
                    <span>{{changeDateToLocalTimeZone(notification.updated_at)| amCalendar:{sameDay:'[Today at] h:mm
          A'} }}</span>
                  </p>
                </div>

                <div class="col-auto px-0">
                  <button type="button" class="btn btn-clear btn-sm text-underline"
                    *ngIf="showViewButton(notification)===true" (click)="goToPage(notification)" attr.aria-label="{{notification.description}} {{notification.notification_category !== IMPORT_TAXONOMY_TO_UPDATE_CATEGORY_VALUE ? 'View' : ''}} {{findCategoryNameByValue(notification.notification_category)}}">
                    {{notification.notification_category !== IMPORT_TAXONOMY_TO_UPDATE_CATEGORY_VALUE ? 'View' : ''}}
                    {{findCategoryNameByValue(notification.notification_category)}}
                  </button>
                </div>

                <div class="col-auto px-0"
                  *ngIf="notification.notification_category === TAXONOMY_EXPORTED_CATEGORY_VALUE">
                  <a [attr.href]="notification.target_context.url" target="_self"
                    class="btn btn-clear btn-sm text-underline">
                    Download
                  </a>
                </div>

              </div>
            </li>
          </ul>
        </div>
      </section>
    </li>
  </ul>
</ng-container>
